<template>
    <b-alert variant="warning" show>
        <h5>
            <font-awesome-icon icon="fa-duotone fa-triangle-exclamation" />
            {{ $t("Automatic Charge Failed") }}
        </h5>

        <div>
            {{ $t("Call will terminate in ") }}
            {{ timer }}
            {{ $t(" seconds if no successful charges are made") }}
        </div>

        <div class="small text-secondary mt-2">
            {{
                $t(
                    "Your most recent charge didn’t go through. This can sometimes happen if the connection is unstable. Please try a manual charge to stay up to date and keep the call going"
                )
            }}
        </div>

        <b-btn
            class="mt-3"
            :disabled="saving"
            variant="primary"
            block
            pill
            @click="manualCharge"
        >
            <h3 class="mb-0">
                {{ $t("Manual Charge") }}
            </h3>
            <div class="small">
                {{ timer }}
                {{ $t("seconds remaining") }}
            </div>
        </b-btn>
    </b-alert>
</template>



<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            timer: 30,
            saving: false,
            countdownInterval: null,
        };
    },
    mounted() {
        this.countdownInterval = setInterval(() => {
            if (this.timer > 0) {
                this.timer--;
            } else {
                if (this.chargeFailed) {
                    this.$store.dispatch("call/hangup");
                }

                clearInterval(this.countdownInterval);
            }
        }, 1000);
    },
    computed: {
        ...mapState("call", ["chargeFailed"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    methods: {
        manualCharge() {
            this.saving = true;

            setTimeout(() => {
                this.saving = false;
            }, 1000);

            this.$store.dispatch("call/charge");
        },
    },
    components: {},
};
</script>